module.exports = "/contribution/resources/19aee65aab513fd489e7f5970de1bdfe.otf";